/**
 * Javascript file for the page to list the existing business models of a user.
 * @author Adrian Rebmann, Steffen Schuhmann, Michael Frey
 */

import {
  getBusinessModel,
  newBusinessmodel,
  deleteBusinessModel,
  getTechnologiesForBm
} from "../../../../api";
export default {
  name: "BMLoad",

  /**
   * The vue instance's data object.
   * @property {boolean} loading - Information is currently being loaded.
   * @property {boolean} deleteActive - The pop-up window to delete a model is active.
   * @property {object} businessmodels - The business models to load.
   * @property {boolean} nameActive - The pop-up window to set the name of a new model is active.
   * @property {boolean} setRecommendationsActive - Activate the recommendations.
   * @property {object} nameValue - The name of the current business model.
   * @property {string} modeltodelete - The business model's name to delete.
   * @property {object} recommendations - The recommendations for the business model.
   */
  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        duration: Infinity
      },
      loading: false,
      deleteActive: false,
      businessmodels: null,
      nameActive: false,
      setRecommendationsActive: false,
      nameValue: null,
      modeltodelete: "",
      recommendations: []
    };
  },

  /**
   * Called after the instance was created.
   */
  created() {
    this.loading = true;
    getBusinessModel().then(res => {
      //console.log(res);
      this.businessmodels = res;
      this.loading = false;
    });
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Checks if there are still questions to be answered in regards
     * to the business model passed as a parameter.
     * @param {*} businessmodel - The business model.
     */
    checkContinueWithQuestions(businessmodel) {
      for (let i = 0; i < businessmodel.bricks.length; i++) {
        if (!businessmodel.bricks[i].donewithquestions) {
          return true;
        }
      }
      return false;
    },

    /**
     * Loads the recommendations for the business model.
     * @param {*} hash - The hash for the business model.
     */
    loadRecommendations(hash) {
      this.recommendations = [];
      getTechnologiesForBm(hash)
        .then(recommendations => {
          this.recommendations = recommendations;
          this.setRecommendationsActive = true;
        })
        .catch(err => {
          //console.log(err);
        });
    },

    /**
     * Shortens the description of the business model.
     * @param {*} desc - Description of the business model.
     */
    shorten(desc) {
      var res = desc.substring(0, 500) + "...";
      return res;
    },

    /**
     * Return to the previous page.
     */
    goBack() {
      this.$router.push({
        name: "BMMenu"
      });
    },

    /**
     * Creates a new business model.
     */
    createNew() {
      newBusinessmodel(this.nameValue).then(res => {
        this.$router.push({
          name: "Brick",
          params: { hash: res.hash, name: "Kundensegment" }
        });
      });
    },

    /**
     * Deletes a business model.
     */
    deleteBm() {
      this.loading = true;
      this.businessmodels = null;
      deleteBusinessModel(this.modeltodelete)
        .then(res => {
          // Update bm data
          getBusinessModel().then(res => {
            this.businessmodels = res;
            this.loading = false;
            this.modeltodelete = "";
          });          
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/company/businessmodel/load/bmload.js